import { z } from 'zod';

// Centrálny register zmlúv (Týž. 21, plán §D) — zmluvy so štátom, zistené
// priamym prieskumom celého Slovensko.Digital datahub katalógu 2026-07-18.
// Viď apps/api opendata-bulk-sync/crz-*.ts.
export const crzContractSchema = z.object({
  id: z.string(),
  contractIdentifier: z.string().nullable(),
  contractingAuthorityName: z.string().nullable(),
  contractingAuthorityIco: z.string().nullable(),
  supplierName: z.string().nullable(),
  supplierIco: z.string().nullable(),
  subject: z.string().nullable(),
  subjectDescription: z.string().nullable(),
  signedOn: z.string().nullable(),
  effectiveFrom: z.string().nullable(),
  effectiveTo: z.string().nullable(),
  priceAmount: z.string().nullable(),
  priceTotalAmount: z.string().nullable(),
  departmentName: z.string().nullable(),
  publishedAt: z.string().nullable(),
  authorityCompanyId: z.string().nullable(),
  supplierCompanyId: z.string().nullable(),
});
export type CrzContract = z.infer<typeof crzContractSchema>;

export const crzFeedResponseSchema = z.object({
  results: z.array(crzContractSchema),
  total: z.number(),
  page: z.number(),
  pageSize: z.number(),
});
export type CrzFeedResponse = z.infer<typeof crzFeedResponseSchema>;

// "Rizikoví dodávatelia štátu" (2026-07-18) — firmy, ktoré podpísali zmluvu so
// štátom AŽ PO tom, čo už boli v konkurze/reštrukturalizácii/likvidácii.
export const riskySupplierSchema = z.object({
  ico: z.string(),
  name: z.string().nullable(),
  // Aktuálne rizikové skóre firmy (2026-07-19, po hromadnom prepočte pre
  // 637 798 firiem) — nezávislé od insolvenčného časovania nižšie.
  riskScore: z.number().nullable(),
  contractCount: z.number(),
  totalAmount: z.number(),
  firstInsolvencyDate: z.string(),
  insolvencyTypes: z.array(z.string()),
  latestSignedOn: z.string(),
});
export type RiskySupplier = z.infer<typeof riskySupplierSchema>;

export const riskySuppliersResponseSchema = z.object({
  results: z.array(riskySupplierSchema),
  total: z.number(),
  page: z.number(),
  pageSize: z.number(),
});
export type RiskySuppliersResponse = z.infer<typeof riskySuppliersResponseSchema>;
